import { Link } from 'react-router-dom';
import { useEffect, useRef } from 'react';

export default function ApproachSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.15 }
    );
    const els = ref.current?.querySelectorAll('.section-appear') ?? [];
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref}>
      {/* Approach section */}
      <section className="py-24 lg:py-36 px-6 bg-neutral-50">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="section-appear">
            <p className="text-xs font-semibold text-neutral-400 uppercase tracking-widest mb-5">Approche</p>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-neutral-900 font-light leading-tight mb-8">
              Simplicité,<br />
              <em className="italic">efficacité</em>
            </h2>
            <p className="text-neutral-500 leading-relaxed text-sm md:text-base max-w-md">
              Chaque projet est réalisé avec attention afin de proposer des solutions simples, efficaces et parfaitement adaptées à chaque situation. Le design doit être au service de vos objectifs.
            </p>
          </div>
          <div className="section-appear lg:pl-8">
            <img
              src="https://public.readdy.ai/ai/img_res/50af30191dc34f9de21735a556f1f05f.jpg"
              alt="Notre approche du design"
              className="w-full h-72 lg:h-80 object-cover object-top rounded-sm"
            />
          </div>
        </div>
      </section>

      {/* CTA section */}
      <section className="py-24 lg:py-32 px-6 bg-neutral-900">
        <div className="max-w-7xl mx-auto text-center">
          <p className="section-appear text-xs font-semibold text-neutral-400 uppercase tracking-widest mb-5">Votre projet</p>
          <h2 className="section-appear font-heading text-4xl md:text-5xl lg:text-6xl text-white font-light leading-tight mb-8">
            Contactez-nous pour<br />
            <em className="italic">discuter de votre projet</em>
          </h2>
          <div className="section-appear">
            <Link
              to="/contact"
              className="inline-block px-10 py-4 bg-white text-neutral-900 text-sm font-medium rounded-sm hover:bg-neutral-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              Prendre contact
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
